import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import Folder from 'owa-mail-store/lib/store/schema/Folder';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isFolderSupported from './isFolderSupported';
import { getStore } from 'owa-mail-store/lib/store/Store';

// Same order as in OWA:MailFolderTreeNodeViewModel.cs
const FOLDERS_TO_SHOW_FIRST: DistinguishedFolderIdName[] = [
    'inbox',
    'junkemail',
    'drafts',
    'sentitems',
    'deleteditems',
];

function getFolderByDistinguishedId(distinguishedId: DistinguishedFolderIdName): Folder {
    const store = getStore();
    const folderTable = store.folders.folderTable;
    const folderId = folderNameToId(distinguishedId);
    return folderTable.get(folderId);
}

export default function getMailRootFolderIds(): string[] {
    const store = getStore();
    const childFolderIds: string[] = [];
    const { rootFolder, folderTable } = store.folders;

    // First add all the special folders.
    FOLDERS_TO_SHOW_FIRST.forEach(distinguishedFolderId => {
        const folder = getFolderByDistinguishedId(distinguishedFolderId);
        if (folder && isFolderSupported(folder)) {
            childFolderIds.push(folder.FolderId.Id);
        }
    });

    // Add all the remaining folders that are not part of the special list above.
    if (rootFolder && rootFolder.childFolderIds) {
        rootFolder.childFolderIds.map(childId => {
            const folder = folderTable.get(childId);
            if (
                folder &&
                FOLDERS_TO_SHOW_FIRST.indexOf(folderIdToName(folder.FolderId.Id)) === -1 &&
                isFolderSupported(folder)
            ) {
                childFolderIds.push(folder.FolderId.Id);
            }
        });
    }

    return childFolderIds;
}
